import React from 'react';

import Icon from '../../../../Common/DesignSystem/Icons/Icon';
import { P3, P3Bold } from '../../../../Common/DesignSystem/Text';
import { DeviceStatus } from '../DeviceStatus';

import { textStyles } from './styles';

export const VehicleDeviceInfo = ({ device, vin, licensePlate }) => {
	const isDeviceOnline = device?.deviceStatus?.isDeviceCommunicating;

	return (
		<>
			<div className='vehicle-info'>
				{Boolean(vin) && <P3 style={textStyles.identification}>{vin}</P3>}
				{Boolean(licensePlate) && <P3 style={textStyles.identification}>{licensePlate}</P3>}
			</div>
			<div className='device-info'>
				<Icon name="Tracker" size={15} />
				{device ? (
					<>
						<P3Bold style={textStyles.serialNumber}>{device?.serialNumber}</P3Bold>
						<DeviceStatus isDeviceOnline={isDeviceOnline} textStyle={textStyles.deviceStatus} />
					</>
				) : (
					<P3 style={textStyles.missingData}>Missing GPS device data</P3>
				)}
			</div>
		</>
	)
};
